const PriceTableSelect = ({ calcData = {}, selectClassName = '' } = {}) => {
  const { academicLevels } = calcData;
  const selectWrapperNode = document.createElement('div');
  const selectContainerNode = document.createElement('div');
  const selectLabelNode = document.createElement('label');
  const selectNode = document.createElement('select');
  const priceTableContainer = document.querySelector('[data-pricing-table]');

  selectLabelNode.innerText = 'Academic level';
  selectLabelNode.classList.add(`${selectClassName}__label`);
  selectContainerNode.classList.add(`${selectClassName}__container`);
  selectWrapperNode.classList.add(selectClassName);
  selectNode.classList.add('select');
  selectWrapperNode.appendChild(selectContainerNode);
  selectContainerNode.appendChild(selectLabelNode);
  selectContainerNode.appendChild(selectNode);

  academicLevels.forEach((level) => {
    const optionNode = document.createElement('option');
    optionNode.value = level.id;
    optionNode.innerText = level.title;
    selectNode.appendChild(optionNode);
  });

  selectNode.addEventListener('change', (e) => {
    const deadlinesNodes = [...document.querySelectorAll('td[data-deadline-id]')];
    const { selectedIndex, options } = e.target;
    const currentSelectValue = options[selectedIndex].value;

    deadlinesNodes.forEach((deadlineCell) => {
      deadlineCell.classList.remove('deadline-active');
      if (deadlineCell.dataset.deadlineId === currentSelectValue)
        deadlineCell.classList.add('deadline-active');
    });
  });

  if (calcData) {
    priceTableContainer.appendChild(selectWrapperNode);
  }
};

export default PriceTableSelect;
